export default __webpack_public_path__ + "static/media/guide_045.f809d405.md";